import React, { useState, useEffect, useRef } from "react";
import debounce from "lodash/debounce";
import { Col } from "react-bootstrap";
import { string, number, oneOfType, object } from "prop-types";

const ScoreScaleWithPoles = ({
  score,
  maxScore,
  cellSpan,
  scoreRangeLimits,
}) => {
  const [scaleWidth, setScaleWidth] = useState(null);

  const scale = useRef(null);

  useEffect(() => {
    function handleResize() {
      // Set window width/height to state
      if (scale.current) {
        setScaleWidth(Math.round(scale.current.getBoundingClientRect().width));
      }
    }

    // Add event listener
    window.addEventListener("resize", debounce(handleResize, 150));

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", () => handleResize);
  }, []);

  if (maxScore) {
    const numberOfCells = maxScore / cellSpan;
    const cellWidth = 100 / numberOfCells;

    return (
      <Col className="px-0" ref={scale} style={{ height: "55px" }}>
        <ul className="numbered score-scale-row">
          {Array.from({ length: numberOfCells }).map((_, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={i} style={{ width: `${cellWidth}%` }}></li>
          ))}
        </ul>
        {score && scaleWidth && (
          <div
            className="scale-score-bubble"
            style={{
              left: `${Math.round((score / maxScore) * scaleWidth)}px`,
              top: "-32px",
            }}
          >
            <strong>{score}</strong>
          </div>
        )}
        {scoreRangeLimits && scaleWidth && (
          <div
            className="scale-score-range-highlight-green"
            style={{
              left: `${Math.round(
                (Number(scoreRangeLimits.get("low")) / maxScore) * scaleWidth
              )}px`,
              width: `${Math.round(
                ((Number(scoreRangeLimits.get("high")) -
                  Number(scoreRangeLimits.get("low"))) /
                  maxScore) *
                  100
              )}%`,
              top: "-35px",
            }}
          ></div>
        )}
      </Col>
    );
  }
};

ScoreScaleWithPoles.propTypes = {
  score: oneOfType([string, number]),
  maxScore: oneOfType([string, number]),
  scoreRangeLimits: object,
  cellSpan: number,
};

export default ScoreScaleWithPoles;
